<template>

  <div class="ca-sidesheet-detalle-historial" v-if="acuerdo_comercial">

    <ca-sidesheet
      :show="show_sidesheet_detalle_historial"
      titulo="DETALLES E HISTORIAL"
      width="600px"
      :close_outside= false
      :loading="loading"
      botonera_inferior
    >

      <!-- Contenedor principal -->
      <div class="contenedor-sidesheet">

        <!-- Header de sidesheet -->
        <header-label-tipo-acuerdo-comercial-sidesheet :acuerdo_comercial="acuerdo_comercial" />

        <!-- Nivel de tabs -->
        <v-tabs class="ca-tabs" v-model="tabs_primer_nivel">
          <v-tab>Detalles del acuerdo</v-tab>
          <v-tab>Historial</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs_primer_nivel">

          <!-- Tab detalles del acuerdo -->
          <v-tab-item>

            <!-- Detalle de estados -->
            <detalle-estado-acuerdo-comercial :acuerdo_comercial="acuerdo_comercial" />

            <!-- Vista previa -->
            <vista-previa-acuerdo
              :acuerdo_comercial="acuerdo_comercial"
              modo_eliminacion
              class="mt-4"
            />

            <!-- Tabla total a facturar (opcional) -->
            <div v-if="acuerdo_comercial.tipo_propuesta === TIPO_ACUERDO_CONSORCIO && !ESTADO_ACUERDO_COMERCIAL_TERMINADORES.includes(acuerdo_comercial.estado)" class="pt-4">

              <!-- Utilizamos el slot para inyectar la tabla de totales a facturar -->
              <div slot="post-observaciones-facturacion">
                <tabla-total-a-facturar-acuerdo-comercial
                  v-if="acuerdo_comercial.consorcio"
                  :acuerdo_comercial="acuerdo_comercial"
                  :consorcio="acuerdo_comercial.consorcio"
                />
              </div>

            </div>

          </v-tab-item>

          <!-- Historial -->
          <v-tab-item>
            <vista-historial-acuerdo-comercial :acuerdo_comercial="acuerdo_comercial" class="mt-2"/>
          </v-tab-item>

        </v-tabs-items>

      </div>

      <!-- Footer con los botones de acciones -->
      <div slot="footer-izquierda">
        <v-btn
          v-if="!ESTADO_ACUERDO_COMERCIAL_TERMINADORES.includes(acuerdo_comercial.estado)"
          class="boton-editar"
          outlined
          @click="abrirSidesheetEdicion()"
        >
          Editar
        </v-btn>
      </div>
      <div slot="footer-derecha">
        <v-btn @click="cerrarSidesheet()">Cerrar</v-btn>
      </div>

    </ca-sidesheet>

  </div>

</template>

<script>
import { AcuerdoComercial } from '@/models/AcuerdoComercial';
import './vistas-sidesheet/vistas-sidesheet-style.scss'; // Estilos en común para las vistas
import HeaderLabelTipoAcuerdoComercialSidesheet from './HeaderLabelTipoAcuerdoComercialSidesheet.vue';
import DetalleEstadoAcuerdoComercial from './DetalleEstadoAcuerdoComercial.vue';
import VistaPreviaAcuerdo from './vistas-sidesheet/VistaPreviaAcuerdo.vue';
import { ESTADO_ACUERDO_COMERCIAL_TERMINADORES, TipoAcuerdo } from '../acuerdo-comercial.consts';
import TablaTotalAFacturarAcuerdoComercial from './TablaTotalAFacturarAcuerdoComercial.vue';
import VistaHistorialAcuerdoComercial from './vistas-sidesheet/VistaHistorialAcuerdoComercial.vue';

/**
 * Componente que muestra el detalle e historial de un acuerdo comercial
 * 
 * Estados terminadores: Estados en los cuales ya no es posible realizar modificaciones en el acuerdo comercial
 * 
 * Condiciones de visualización de la tabla de totales a facturar:
 * - Solo se muestra si el tipo de acuerdo es al consorcio
 * - Solo se muestra si el estado del acuerdo no es terminador
 * 
 * Condiciones de visualización del botón de editar:
 * - Solo se muestra si el estado del acuerdo no es terminador
 * 
 * En caso de que el acuerdo este expirado se muestran ambos componentes
 */
export default {
  name: 'SidesheetDetalleHistorialAcuerdoComercial',
  components: {
    HeaderLabelTipoAcuerdoComercialSidesheet,
    DetalleEstadoAcuerdoComercial,
    VistaPreviaAcuerdo,
    TablaTotalAFacturarAcuerdoComercial,
    VistaHistorialAcuerdoComercial
  },
  props: {
    show_sidesheet_detalle_historial: { type: Boolean, default: false },
    acuerdo_comercial: { type: AcuerdoComercial, default: null },
    abrir_tab_historial: { type: Boolean, default: false }, // Flag para abrir el sidesheet en el tab de historial
  },
  data: () => ({
    loading: false,
    tabs_primer_nivel: 0,
    TIPO_ACUERDO_CONSORCIO: TipoAcuerdo.CONSORCIO,
    ESTADO_ACUERDO_COMERCIAL_TERMINADORES: ESTADO_ACUERDO_COMERCIAL_TERMINADORES
  }),
  watch: {

    /**
     * Watch para accionar y definir que tab se debe abrir
     *  - En caso que el flag para abrir el tab historial sea verdadero: se muestra el tab del historial
     *  - Caso contrario: Se muestra el tab de detalles del acuerdo
     */
    show_sidesheet_detalle_historial(mostrar_sidesheet_detalle_historial) {
      if (mostrar_sidesheet_detalle_historial) {
        this.tabs_primer_nivel = this.abrir_tab_historial ? 1 : 0;
      }
    }
  },
  methods: {

    /** 
     * Metodo encargado de emitir evento al padre para que se abra el sidesheet de edición 
     */
    abrirSidesheetEdicion() {
      this.cerrarSidesheet(); // Cerramos el sidesheet actual
      this.$emit('abrir-sidesheet-edicion', this.acuerdo_comercial); // Emitimos evento para abrir el sidesheet de edición
    },

    /**
     * Metodo ejecutado al hacer click en el boton de cerrar del sidesheet
     */
    cerrarSidesheet(){
      this.$emit('update:show_sidesheet_detalle_historial', false);
    },
  }
};

</script>

<style lang="scss">
.ca-sidesheet-detalle-historial {

  .v-toolbar__title {
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
  }

  .v-card__actions {
    padding: 8px 16px;
  }

  .ca-tabs {
    .v-tab {
      width: 100%; // Necesario para que se ocupe todo el ancho disponible
    }
  }

  .boton-editar {
    color: color(naranja);
    background-color: inherit;
  }

}
</style>